import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class MaskBadge extends WritingBadge {
  public readonly id = BadgeId.mask;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.streakInfo.current >= 100 || stats.streakInfo.longest >= 100;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/mask.ts